export const GET_MARKETS_REQUEST = 'GET_MARKETS_REQUEST';
export const GET_MARKETS_SUCCESS = 'GET_MARKETS_SUCCESS';
export const GET_MARKETS_ERROR = 'GET_MARKETS_ERROR';

export const GET_CLIENT_MARKETS_REQUEST = 'GET_CLIENT_MARKETS_REQUEST';
export const GET_CLIENT_MARKETS_SUCCESS = 'GET_CLIENT_MARKETS_SUCCESS';
export const GET_CLIENT_MARKETS_ERROR = 'GET_CLIENT_MARKETS_ERROR';

export const UPDATE_MARKET_REQUEST = 'UPDATE_MARKET_REQUEST';
export const UPDATE_MARKET_SUCCESS = 'UPDATE_MARKET_SUCCESS';
export const UPDATE_MARKET_ERROR = 'UPDATE_MARKET_ERROR';
